import React from 'react';
import { CircularProgress, Button, Paper } from '@material-ui/core';
import T from 'i18n-react';

import Config from '@apricityhealth/web-common-lib/Config';
import { AxiosRequest } from '@apricityhealth/web-common-lib/utils/Axios';
import { Logger } from '@apricityhealth/web-common-lib';

const log = new Logger();

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px',
        minHeight: '40vh'
    },
    panel: {
        padding: '24px',
        maxWidth: '480px',
        textAlign: 'center'
    },
    actions: {
        marginTop: '16px'
    }
};

export class ConsolidatedHealthCallbackView extends React.Component {
    constructor(props) {
        super(props);
        this.state = { status: 'pending', errorKey: null };
    }

    componentDidMount() {
        //const params = new URLSearchParams(window.location.search);
        const code = sessionStorage.getItem('chCode'); //params.get('code');
        const state = sessionStorage.getItem('chState'); //params.get('state');
        const storedState = sessionStorage.getItem('chOAuthState');
        const storedPatientId = sessionStorage.getItem('chOAuthPatientId');
        const storedRedirectUri = sessionStorage.getItem('chOAuthRedirectUri');

        sessionStorage.removeItem('chOAuthState');
        sessionStorage.removeItem('chOAuthPatientId');
        sessionStorage.removeItem('chOAuthRedirectUri');
        sessionStorage.removeItem('chCode');
        sessionStorage.removeItem('chState');

        if (!code || !state || !storedState || !storedPatientId || state !== storedState) {
            log.error('Consolidated Health callback validation failed', { hasCode: !!code, stateMatches: state === storedState, hasPatientId: !!storedPatientId });
            this.setState({ status: 'error', errorKey: 'consolidatedHealth-state-mismatch' });
            return;
        }

        const { appContext, appContext: { state: { idToken }} } = this.props;

        const body = { code };
        if (storedRedirectUri) body.redirectUri = storedRedirectUri;

        const request = {
            url: Config.baseUrl + `${Config.pathPrefix}apricity-cleanse/consolidated-health/link/${encodeURIComponent(storedPatientId)}`,
            method: 'POST',
            headers: { Authorization: idToken },
            data: body
        };

        log.info("request:", request );
        AxiosRequest(request).then(() => {
            if (typeof appContext.reloadPatient === 'function') appContext.reloadPatient();
            this.setState({ status: 'success' });
            window.setTimeout(() => {
                if (this.props.appContext && this.props.appContext.props && this.props.appContext.props.history) {
                    this.props.appContext.props.history.replace('/dashboard');
                } else {
                    window.location.replace('/dashboard');
                }
            }, 1500);
        }).catch((err) => {
            log.error('Consolidated Health link request failed:', err);
            this.setState({ status: 'error', errorKey: 'consolidatedHealth-error' });
        });
    }

    renderBody() {
        const { status, errorKey } = this.state;
        if (status === 'pending') {
            return <div><CircularProgress /></div>;
        }
        if (status === 'success') {
            return <div><T.span text="consolidatedHealth-success" /></div>;
        }
        return <div>
            <div><T.span text={errorKey || 'consolidatedHealth-error'} /></div>
            <div style={styles.actions}>
                <Button variant="contained" color="primary" onClick={() => window.location.replace('/dashboard')}>
                    <T.span text="dashboard" />
                </Button>
            </div>
        </div>;
    }

    render() {
        return <div style={styles.container}>
            <Paper style={styles.panel}>
                {this.renderBody()}
            </Paper>
        </div>;
    }
}

export default ConsolidatedHealthCallbackView;
